// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-privacy-js": () => import("./../../../src/pages/privacy.js" /* webpackChunkName: "component---src-pages-privacy-js" */),
  "component---src-pages-privacyeu-js": () => import("./../../../src/pages/privacyeu.js" /* webpackChunkName: "component---src-pages-privacyeu-js" */),
  "component---src-pages-tou-js": () => import("./../../../src/pages/tou.js" /* webpackChunkName: "component---src-pages-tou-js" */),
  "component---src-pages-upload-js": () => import("./../../../src/pages/upload.js" /* webpackChunkName: "component---src-pages-upload-js" */)
}

